import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type GetLineItemTreatedByMerchantQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
};

export function getLineItemTreatedByMerchantQuantity({
  lineItem,
}: GetLineItemTreatedByMerchantQuantityParams) {
  return lineItem.merchant_informations.reduce(
    (acc, merchantInformation) => acc + merchantInformation.quantity,
    0,
  );
}
